<template>
  <div>
    <div>
      <quill-editor
        v-model="content"
        ref="myQuillEditor"
        :options="editorOption"
        @change="onEditorChange($event)"
      >
      </quill-editor>
    </div>
    <div v-show="false">
      <el-upload
        class="quill-img"
        :disabled="disabled"
        :headers="{
          'x-oss-security-token': ossData.security_token,
        }"
        :action="fileBaseUrl"
        :show-file-list="false"
        :data="{
          key: ossData.key + this.temp,
          OSSAccessKeyId: ossData.keyId,
          policy: ossData.policy,
          signature: ossData.signature,
          'x-oss-security-token': ossData.security_token,
        }"
        :on-success="handleUploadSuccess"
      >
      </el-upload>
    </div>
  </div>
</template>
  
<script>
// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link"], // 链接、图片、视频
  // "image", "video"
];

import { Base64 } from "js-base64";
import { encode, decode } from "js-base64";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      fileBaseUrl: "https://salt-images.oss-cn-shanghai.aliyuncs.com",
      baseUrl: "https://jewel.salt87.com",
      lang: localStorage.getItem("lang") || "zh_CN",
      visible: false,
      ossData: "",
      temp: "",
      content: "",
      editorOption: {
        placeholder: "",
        theme: "snow", // or 'bubble'
        placeholder: "请输入内容",
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".quill-img input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
    };
  },
  props: {
    value: {
      default: "",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  watch: {
    value: function() {
      this.content = this.value;
    }
  },
  mounted() {
    // this.getOss();
    // this.getTemp();
    this.content = this.value;
  },
  methods: {
    onEditorChange() {
      //内容改变事件
      this.$emit("input", this.content);
    },

    // 图片上传
    handleUploadSuccess(response, file, fileList) {
      let data = this.fileBaseUrl + "/" + this.ossData.key + this.temp;
      this.getTemp();

    
      let quill = this.$refs.myQuillEditor.quill;
      // 获取光标所在位置
      let length = quill.getSelection().index;
      // 插入图片  res.url为服务器返回的图片地址
      quill.insertEmbed(length, "image", data);
      // 调整光标到最后
      quill.setSelection(length + 1);
    },
    getTemp() {
      const date = new Date();
      this.temp = date.getTime();
    },
    getOss() {
      this.$request.getOss().then((res) => {
        console.log(CryptoJS);
        const date = new Date();
        date.setHours(date.getHours() + 1);
        const policyText = {
          expiration: date.toISOString(), // 设置policy过期时间。
          conditions: [
            // 限制上传大小。
            ["content-length-range", 0, 1024 * 1024 * 1024],
          ],
        };
        const policy = encode(JSON.stringify(policyText)); // policy必须为base64的string。
        const signature = CryptoJS.enc.Base64.stringify(
          CryptoJS.HmacSHA1(policy, res.data.access_key_secret)
        );
        const key = "img" + localStorage.getItem("token");
        const avatar = this.baseUrl + "/" + key;
        const keyId = res.data.access_key_id;
        const security_token = res.data.security_token;

        let obj = {
          policy,
          signature,
          key,
          avatar,
          keyId,
          security_token,
        };

        this.ossData = obj;
      });
    },
  },
};
</script>
  
  <style scoped>
.pic-uploader-component .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.pic-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.pic {
  width: 178px;
  height: 178px;
  display: block;
}
.pic-uploader-component .el-upload:hover {
  border-color: #409eff;
}
.upBlock {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/editor.vue